const results = require('../cjs/crc16ccitt').default;
module.exports = results;
module.exports.default = results;
